export const EXCEPTION_STATUS = {
  SUCCESS: 0,
  ERROR: 0
};

export const ERROR_CODES = {
  AUTH_FAILED: 'auth/failed',
  CREATE_USER_FAILED: 'create-user-collection/failed'
};

export const COLLECTION_NAMES = {
  USERS: 'usuarios',
  PRODUCTS: 'produtos',
  TRANSACTIONS: 'transactions',
  TRANSACTIONS_ITEMS: 'transactions-items',
  PLANS: 'permissions'
};

export const StoragePath = {
  userPhoto: (userID, photoName) => `imagens/${userID}/${photoName}`
};
